/**
 * The idea is to share data between related components without passing props through every level.
 * Symbol() guarantees the key is unique, avoiding collisions.
 */
export const FORM_ITEM_INJECTION_KEY = Symbol();
